import { render } from "./PortfolioSegment.vue?vue&type=template&id=0dfe0820&scoped=true&ts=true"
import script from "./PortfolioSegment.vue?vue&type=script&lang=ts"
export * from "./PortfolioSegment.vue?vue&type=script&lang=ts"

import "./PortfolioSegment.vue?vue&type=style&index=0&id=0dfe0820&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfe0820"]])

export default __exports__